module.exports = __webpack_public_path__ + "img/download.9b1b349e.svg";